import Axios from "axios";

interface Request {
    method?: "get" | "post" | "put" | "delete",
    url?: string,
    data?: Object | null,
    additionalHeaders?: Object | null,
    config?: Object | null,
    params?: Object | null,
    logged?: boolean,
}

const instance = Axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 30000,

})

const request = (
    {
        method,
        url,
        data = null,
        additionalHeaders = null,
        config = null,
        params = null,
        // logged = false,
    }: Request
): any => {
    return new Promise(async (resolve, reject) => {
        const headers = Object.assign({}, additionalHeaders)

        // if (logged) {
        //     const token = await AsyncStorage.getItem('@Store:token')
        //     headers.Authorization = `Bearer ${token}`
        // }

        instance.request({
            method,
            url,
            data,
            params,
            headers,
            ...config,
        })
            .then(resolve)
            .catch(reject)
    })
}

export const get = (
    {
        url,
        logged = false,
        params = null,
        config = null,
    }: Request
) => {
    return request({
        method: "get",
        url,
        logged,
        params,
        config,
    })
}


export const post = (
    {
        url,
        logged = false,
        data = null,
        config = null,
        additionalHeaders = null,
    }: Request
) => {
    return request({
        method: "post",
        url,
        logged,
        data,
        config,
        additionalHeaders,
    })
}

export const put = (
    {
        url,
        logged = false,
        data = null,
        config = null,
        additionalHeaders = null,
    }: Request
) => {
    return request({
        method: "put",
        url,
        logged,
        data,
        config,
        additionalHeaders,
    })
}

export const method = (
    {
        method,
        url,
        logged = false,
        data = null,
        config = null,
        additionalHeaders = null,
    }: Request
) => {
    return request({
        method,
        url,
        logged,
        data,
        config,
        additionalHeaders,
    })
}

